import { Button, Typography } from 'antd'
import * as React from 'react'
import { useCallback, useEffect, useState } from 'react'

import { EditableLabel } from '../../editable-label'

import { CloseIcon } from '../../icons'

import * as styles from './NewItem.module.less'
import * as itemStyles from './Item.module.less'

const { Text } = Typography

export interface NewItemProps {
	onCancelNewItem: () => void
	onSaveNewItem: (data: string) => void
	saveButtonTitle?: string
}
export const NewItemDefault: React.FC<NewItemProps> = (props) => {
	const { onCancelNewItem, onSaveNewItem, saveButtonTitle } = props
	const initialValue = 'New item'
	const [ data, setData ] = useState(initialValue)
	const [ isDataValidated, setIsDataValidated ] = useState(false)
	const [ key, setKey ] = useState(() => Math.random())

	const keyDown = useCallback((event) => {
		if (event.keyCode === 27) {			
			// On Escape
            if (onCancelNewItem) {
                onCancelNewItem()
            }
		} else if (event.keyCode === 13) {
			// On Enter
			// saveNewItem()
		}
	}, [])

	useEffect(() => {
		document.addEventListener('keydown', keyDown, false)

		return () => {
			document.removeEventListener('keydown', keyDown, false)
		}
	}, [])

	const validateData = () => {
		setIsDataValidated(data !== undefined)
	}

	useEffect(
		() => {
			validateData()
		},
		[ data ]
	)

	const reset = () => {
		setKey(Math.random())
		setData(initialValue)
	}

	const saveNewItem = () => {
		if (isDataValidated) {
			onSaveNewItem(data)
			reset()
		}
	}

	const onSaveTitle = (savedValue: string) => {
		setData(savedValue)
	}

	return (
		<div key={key} className={itemStyles.item}>
			<div className={styles.newItem}>
				<EditableLabel
					canEdit={true}
					initialValue={data}
					focusOnMount={true}
					onSave={onSaveTitle}
					htmlTag='span'
					editOnClick={true}
					setCursorOnFocus='selectAll'
				/>
			</div>
			<Button type='primary' onClick={saveNewItem}>
				{saveButtonTitle || 'Save'}
			</Button>
			<Button type='link' onClick={onCancelNewItem}>
				<Text type='secondary'>
					<CloseIcon />
				</Text>
			</Button>
		</div>
	)
}
